import { render, staticRenderFns } from "./ReportMortalityMother.vue?vue&type=template&id=65ba65d0&scoped=true"
import script from "./ReportMortalityMother.vue?vue&type=script&lang=js"
export * from "./ReportMortalityMother.vue?vue&type=script&lang=js"
import style0 from "./ReportMortalityMother.vue?vue&type=style&index=0&id=65ba65d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba65d0",
  null
  
)

export default component.exports